
// Get the value of the cookie with cName, return null if it does not exist
export function getCookie(cName: string) {
  let value = null
  const ac = document.cookie
  let start = ac.indexOf(`${cName}=`)
  if (start >= 0) {
    start += cName.length + 1
    let end = ac.indexOf(';', start)
    if (end === -1) {
      end = ac.length
    }
    value = decodeURIComponent(ac.substring(start, end))
  }
  return value
}

export function dropCookie(cName: string) {
  setCookie(cName)
}

export function setCookie(cName: string, value = undefined, age: number = undefined) {
  let dc = `${cName}=`
  if (typeof value !== 'undefined') {
    dc += `${encodeURIComponent(value)}; path=/`
    if (typeof age !== 'undefined') {
      if (age !== -1) {
        const d = new Date()
        d.setTime(d.getTime() + (age * 1000))
        dc += `; Expires=${d.toUTCString()}`
      }
    }
  } else {
    // removes the cookie
    dc += `; path=/; Expires=${new Date(0).toUTCString()}`
  }
  document.cookie = dc
}
